var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full"},[(_vm.currentId !== 'novo')?_c('entity-crud',_vm._b({staticClass:"h-full",attrs:{"shouldShowHeaderName":_vm.shouldShowHeaderName,"tableVariant":"secondary"}},'entity-crud',{
			model: _vm.model,
			title: _vm.title,
			tableColumns: _vm.tableColumns,
			formColumns: _vm.formColumns,
			kind: _vm.kind,
			defaultEntity: _vm.defaultEntity,
			withEntityHeader: _vm.withEntityHeader,
			cleanFormKeys: _vm.cleanFormKeys,
			isReadOnly: _vm.isReadOnly,
			shouldShowExportButton: _vm.shouldShowExportButton,
			onInputChange: _vm.onInputChange,
			// filter,
		},false)):_c('div',{staticClass:"h-full flex flex-col gap-8"},[_c('entity-crud',_vm._b({attrs:{"shouldShowHeaderName":_vm.shouldShowHeaderName}},'entity-crud',{
				model: _vm.model,
				title: _vm.title,
				tableColumns: _vm.tableColumns,
				formColumns: _vm.formColumns,
				onRemoveEntity: _vm.onRemoveEntity,
				shouldGoToPreviousPageAfterRemove: _vm.shouldGoToPreviousPageAfterRemove,
				onInputChange: _vm.onInputChange,
			},false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }